import { Injectable, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs';

import { ApModalResult, ApModalService } from 'webcommon/core-ui';
import { ApBaseClass, FindControlAdditionalSearchParametersDto } from 'webcommon/shared';

import { FcFilterModalContext } from '../models/index';
import { FcFilterConfig } from './fc-filter-config';

@Injectable({
  providedIn: 'root',
})
export class FcFilterModalService extends ApBaseClass implements OnDestroy {
  constructor(
    private apModalService: ApModalService,
    private fcFilterConfig: FcFilterConfig,
  ) {
    super();
  }

  openModal(
    fcFilterModalContext: FcFilterModalContext,
  ): Observable<ApModalResult<FindControlAdditionalSearchParametersDto>> {
    const initialState = {
      fcFilterModalContext,
    };

    const findControlModalType = this.fcFilterConfig.getFilterModalTypeOrDefault(fcFilterModalContext);

    const obs = this.apModalService.showComponentModal$(findControlModalType.component, {
      panelClass: findControlModalType.modalSize,
      disableClose: true,
      initialState,
    });

    return obs;
  }
}
